import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from "react-router-dom";
import Select from 'react-select';
import PropTypes from 'prop-types';
import { Form } from 'react-bootstrap';
import { fetchTimesheetTasksDropdown } from 'actions';
import { isArray, isEmpty, map, find, isEqual } from 'lodash';
import { CustomDropdownContainer } from 'CommonComponent';

const TimesheetTaskDropdown = ({ 
  selectedId = '',
  selectedChangingId = '',
  taskValue,
  setTaskValue,
  taskOnChange,
  setAllTaskIds,
  showSelectAllOption = true,
  isMulti = true,
  placeholder = 'Select Task',
  label = 'Task',
  name = 'task_id',
  category_id = null,
  programId,
  loadUnbinded = false,
  user_ids = null
}) => {
  const dispatch = useDispatch();
    const location = useLocation();
  const session = useSelector((s) => s.session);
  const taskList = useSelector(state => state.timeSheetTaskState.tasksDropdownList);

  console.log('Task List from Redux:', taskList);
  const [options, setOptions] = useState([]);

  useEffect(() => {
    
    if (session?.current_page_permissions?.page_url === location.pathname) {
    fetchTask();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [category_id, programId, user_ids, session.current_page_permissions]);

  useEffect(() => {
    if (!selectedChangingId || !taskList) return;

    if (isArray(selectedChangingId)) {
      const selected = selectedChangingId.map(id =>
        find(taskList, ['id', id])
      ).filter(Boolean).map(item => ({ value: item.id, label: item.name }));
      setTaskValue(selected);
    } else {
      const selected = find(taskList, ['id', selectedChangingId]);
      setTaskValue(selected ? { value: selected.id, label: selected.name } : null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedChangingId, taskList]);


  useEffect(() => {
    if (!taskList) return;

    const formattedOptions = map(taskList, item => ({
      value: item.id,
      label: item.name
    }));

    console.log('Formatted Options:', formattedOptions);

    if (showSelectAllOption && isMulti) {
      formattedOptions.unshift({ value: 'all', label: 'All' });
    }

    setOptions(formattedOptions);

    if (typeof setAllTaskIds === 'function') {
      setAllTaskIds(map(taskList, 'id'));
    }

    if (!isEmpty(selectedId)) {
      if (isArray(selectedId)) {
        const selected = selectedId.map(id =>
          find(formattedOptions, ['value', id])
        ).filter(Boolean);

        if (!isEqual(taskValue, selected)) {
          setTaskValue(selected);
        }
      } else {
        const selected = find(formattedOptions, ['value', selectedId]);
        if (!isEqual(taskValue, selected)) {
          setTaskValue(selected || null);
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [taskList, selectedId, isMulti, showSelectAllOption]);

  const fetchTask = () => {

    let category_ids = [];
    if (category_id) {
      category_ids = Array.isArray(category_id) ? category_id : [category_id];

    }

    let params = {
      object_viewed_id: session?.current_page_permissions?.object_id || '',
      category_ids
    };

    if(programId !== undefined && programId !== null){
      params.load_unbinded = loadUnbinded;
      params.program_id = programId;
    }

    if(user_ids !== undefined && user_ids !== null && user_ids.length > 0){
      params.user_ids = user_ids;
    }

    dispatch(fetchTimesheetTasksDropdown(params));

  }

  return (
    <>
      <Form.Group className="mb-3">
        <Form.Label className="label-input">{label}</Form.Label>
        <Select
          name={name}
          options={options}
          value={taskValue}
          onChange={taskOnChange}
          isMulti={isMulti}
          placeholder={placeholder}
          className="multi-select w-100"
          classNamePrefix="react-select"
          isSearchable
          components={{ ValueContainer: CustomDropdownContainer }}
        />
      </Form.Group>
    </>
  );
};

TimesheetTaskDropdown.propTypes = {
  taskOnChange: PropTypes.func.isRequired,
  setTaskValue: PropTypes.func.isRequired,
  taskValue: PropTypes.any,
  selectedId: PropTypes.any,
  selectedChangingId: PropTypes.any,
  setAllTaskIds: PropTypes.func,
  isMulti: PropTypes.bool,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  name: PropTypes.string,
  category_id: PropTypes.any,
  loadUnbinded: PropTypes.bool,
  user_ids: PropTypes.array,
};

export default TimesheetTaskDropdown;
